import useWindowSize from 'components/util/useWindowSize'
import { generateSrcSet } from 'project/image-proxy-web'

const features = [
  {
    description:
      'Embed your virtual phone number on your site to offer immediate help.',
    title: 'Instant support',
  },
  {
    description:
      'Build stronger relationships throughout each customer’s journey.',
    title: 'One-to-one communication',
  },
  {
    description: 'Reply instantly to convert more enquiries into customers.',
    title: 'Increase sales',
  },
  {
    description:
      'All calls and messages run through WhatsApp, using Wi-Fi or mobile data, no extra network costs.',
    title: 'Flexible calls & messages',
  },
  {
    description:
      'Your WhatsApp for Business account can be customised with your company name, logo and business hours. Keeping these details up to date helps customers recognise your brand and builds instant trust.',
    title: 'Managing your WhatsApp for Business Account',
  },
]

const EngageWithCustomers = () => {
  const size = useWindowSize()
  return (
    <div
      className='d-flex flex-column align-items-center mx-auto'
      style={{
        maxWidth: 1074,
      }}
    >
      <h2 className='fs-fluid-36-80 lh-119 lh-lg-105 text-center fw-semibold mb-4 mb-lg-10'>
        Engage with your customers <br /> quickly and efficiently.
      </h2>
      {size.isLgOrHigher ? (
        <img
          className='img-fluid'
          {...generateSrcSet('/images/new/whatsapp/engage.png', 761, 380)}
        />
      ) : (
        <img
          className='img-fluid'
          {...generateSrcSet(
            '/images/new/whatsapp/engage-mobile.png',
            568,
            475,
          )}
        />
      )}
      <div className='pt-lg-17 pt-14 gap-10 d-flex flex-column'>
        <p className='fs-fluid-16-24 fw-semibold color-grey5 mb-0'>
          With a virtual phone number, you can use the WhatsApp Business app to
          connect with customers in real time, improving communication and
          customer satisfaction. Embed the virtual phone number into your
          marketing materials and on your website to get started:
        </p>
        <ul className='d-flex flex-column gap-4'>
          {features.map((feature) => (
            <li className='fs-fluid-16-24 fw-semibold' key={feature.title}>
              <span className='fw-bold'>{feature.title}: </span>
              <span>{feature.description}</span>
            </li>
          ))}
        </ul>
        <p className='fs-fluid-16-24 fw-semibold color-grey5 mb-0'>
          Using WhatsApp creates a more responsive customer support experience.
          Messages are instant, improving customer satisfaction and
          strengthening every interaction. And all of this through a familiar
          interface used by over 3 billion people.
        </p>
      </div>
    </div>
  )
}

export default EngageWithCustomers
